import { Reveal, SectionHeading } from "./Reveal";

const PILLARS = [
  { num: "01", title: "Premium Design", desc: "Every website is designed to make your business look exceptional." },
  { num: "02", title: "Built To Convert", desc: "Design decisions are based around your customers and business goals." },
  { num: "03", title: "Performance First", desc: "Fast, responsive experiences across desktop, tablet and mobile." },
  { num: "04", title: "Built Around You", desc: "No generic templates. Every project is tailored to the business." },
];

const WhyUs = () => (
  <section id="why" data-testid="why-section" className="relative z-10 py-28 sm:py-36">
    <div className="mx-auto max-w-7xl px-6 sm:px-10">
      <SectionHeading
        kicker="Why CLOSER."
        title="Not Just Websites. Digital Experiences."
        testId="why-heading"
      />
      <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2">
        {PILLARS.map((p, i) => (
          <Reveal key={p.num} i={i}>
            <div
              data-testid={`why-panel-${i}`}
              className="group relative overflow-hidden rounded-3xl glass p-9 sm:p-11 transition-[background-color,border-color] duration-500 hover:bg-white/[0.06] hover:border-white/25"
            >
              <span className="font-display pointer-events-none absolute -right-4 -top-8 text-[9rem] font-bold leading-none text-white/[0.04] transition-colors duration-700 group-hover:text-white/[0.08] select-none">
                {p.num}
              </span>
              <span className="font-display text-xs font-semibold tracking-[0.4em] text-white/40">{p.num}</span>
              <h3 className="font-display mt-4 text-2xl sm:text-3xl font-semibold tracking-tight text-white">{p.title}</h3>
              <p className="mt-4 max-w-md text-base font-light leading-relaxed text-white/50">{p.desc}</p>
              <div className="mt-8 h-px w-16 bg-white/30 transition-[width] duration-700 group-hover:w-full" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhyUs;
